export default __webpack_public_path__ + "static/media/photo-blank.055da281.svg";